import _slicedToArray from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { isFocusVisible as $isWE5$isFocusVisible, useFocusVisibleListener as $isWE5$useFocusVisibleListener, useFocus as $isWE5$useFocus, useFocusWithin as $isWE5$useFocusWithin } from "@react-aria/interactions";
import { useRef as $isWE5$useRef, useState as $isWE5$useState, useCallback as $isWE5$useCallback } from "react";
function $f7dceffc5ad7768b$export$4e328f61c538687f() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _props$autoFocus = props.autoFocus,
    autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
    isTextInput = props.isTextInput,
    within = props.within;
  var state = (0, $isWE5$useRef)({
    isFocused: false,
    isFocusVisible: autoFocus || (0, $isWE5$isFocusVisible)()
  });
  var _ref = (0, $isWE5$useState)(false),
    _ref2 = _slicedToArray(_ref, 2),
    isFocused = _ref2[0],
    setFocused = _ref2[1];
  var _ref3 = (0, $isWE5$useState)(function () {
      return state.current.isFocused && state.current.isFocusVisible;
    }),
    _ref4 = _slicedToArray(_ref3, 2),
    isFocusVisibleState = _ref4[0],
    setFocusVisible = _ref4[1];
  var updateState = (0, $isWE5$useCallback)(function () {
    return setFocusVisible(state.current.isFocused && state.current.isFocusVisible);
  }, []);
  var onFocusChange = (0, $isWE5$useCallback)(function (isFocused) {
    state.current.isFocused = isFocused;
    setFocused(isFocused);
    updateState();
  }, [updateState]);
  (0, $isWE5$useFocusVisibleListener)(function (isFocusVisible) {
    state.current.isFocusVisible = isFocusVisible;
    updateState();
  }, [], {
    isTextInput: isTextInput
  });
  var _ref5 = (0, $isWE5$useFocus)({
      isDisabled: within,
      onFocusChange: onFocusChange
    }),
    focusProps = _ref5.focusProps;
  var _ref6 = (0, $isWE5$useFocusWithin)({
      isDisabled: !within,
      onFocusWithinChange: onFocusChange
    }),
    focusWithinProps = _ref6.focusWithinProps;
  return {
    isFocused: isFocused,
    isFocusVisible: isFocusVisibleState,
    focusProps: within ? focusWithinProps : focusProps
  };
}
export { $f7dceffc5ad7768b$export$4e328f61c538687f as useFocusRing };